// src/store/modules/subscription.ts
import { gql } from 'apollo-boost'
import { client } from '@/lib/api'
import { preventError } from '@/utils/'

export default {
  namespaced: true,

  state: () => ({
    roles: [] as any[],
  }),
  mutations: {
    SET_ROLES(state, val: any[]) { state.roles = val },
  },

  actions: {
    async GET_ROLES(
      { commit },
      payload
    ) {
      const { pager, search } = payload;
      const input = {
        pager,
        search
      }
      try {
        const response = await client.query({
          query: gql`
          query getRoles($input: GetRolesInput!) {
            getRoles(input: $input) {
              items {
                id
                name
                type
              }
              pager {
                count
                limit
                offset
              }
            }
          }
        `,
          variables: { input }
        })
        const roles = response.data.getRoles;

        commit('SET_ROLES', roles.items)
        return roles;
      } catch (e) {
        console.error('ERROR', e.message)
        preventError(e);
      }
    },
  },
}

